import apiClient from '@u/apiClient'
import GetBatchOperationSchemaController from '@/wayfinder/actions/App/Http/Controllers/BatchOperation/GetBatchOperationSchemaController'
import GetBatchOperationCandidatesController from '@/wayfinder/actions/App/Http/Controllers/BatchOperation/GetBatchOperationCandidatesController'
import GetBatchOperationCandidateIdsController from '@/wayfinder/actions/App/Http/Controllers/BatchOperation/GetBatchOperationCandidateIdsController'
import PreviewBatchOperationController from '@/wayfinder/actions/App/Http/Controllers/BatchOperation/PreviewBatchOperationController'
import ExecuteBatchOperationController from '@/wayfinder/actions/App/Http/Controllers/BatchOperation/ExecuteBatchOperationController'
import GetBatchOperationRunsController from '@/wayfinder/actions/App/Http/Controllers/BatchOperation/GetBatchOperationRunsController'
import GetBatchOperationRunController from '@/wayfinder/actions/App/Http/Controllers/BatchOperation/GetBatchOperationRunController'
import RenumberBatchOperationController from '@/wayfinder/actions/App/Http/Controllers/BatchOperation/RenumberBatchOperationController'
import GetBatchOperationAutomationsController from '@/wayfinder/actions/App/Http/Controllers/BatchOperation/GetBatchOperationAutomationsController'

export default {
  fetchBatchOperationSchema() {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetBatchOperationSchemaController.get())
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchBatchOperationCandidates(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetBatchOperationCandidatesController.post(), payload)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  /**
   * Returns every id matching the current filters, so "select all" can put explicit
   * ids in the cart instead of storing a filter that would be replayed later.
   */
  fetchBatchOperationCandidateIds(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetBatchOperationCandidateIdsController.post(), payload)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  previewBatchOperation(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(PreviewBatchOperationController.post(), payload)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  /**
   * Feeds the renumbering step: its rows (mode current) or the references its shift and
   * sequence tools propose for the given ordered ids. A read, nothing is written.
   */
  fetchBatchOperationRenumberProposal(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(RenumberBatchOperationController.post(), payload)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  /**
   * A preview with side effects on other entities is refused unless the operator confirmed
   * them, so the flag is only sent true when the screen says so.
   */
  executeBatchOperation(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ExecuteBatchOperationController.post(), {
          preview_key: payload.previewKey,
          confirm_side_effects: payload.confirmSideEffects === true
        })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  /**
   * The tenant's active automations on the given triggers, listed so the operator decides
   * knowingly whether the batch should skip them.
   */
  fetchBatchOperationAutomations(_, triggers: string[]) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetBatchOperationAutomationsController.get(), {
          params: { triggers }
        })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchBatchOperationRuns() {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetBatchOperationRunsController.get())
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  /**
   * The run's lines are cursor paginated: pass the `next_cursor` of the previous page to
   * read the following one.
   */
  fetchBatchOperationRun(_, { runId, cursor = null }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetBatchOperationRunController.get({ run: runId }), {
          params: cursor ? { cursor } : {}
        })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  }
}
